import { PlotImportWizard } from '@/components/plots/plot-import-wizard'

export function AdminPlotsImport() {
  return <PlotImportWizard plotsBasePath="/admin/plots" />
}
